import { FC } from 'react';
import { Box, Typography, TypographyProps, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { CopyIcon } from './CopyElements/CopyIcon';

type Props = TypographyProps & {
  children: Pick<TypographyProps, 'children'>;
  monospace?: boolean;
};

const useStyles = makeStyles<Theme, Partial<Props>>(() => ({
  inline: {
    display: 'inline-flex',
    alignItems: 'center',
    maxWidth: '100%',
  },
  typography: {
    fontFamily: ({ monospace }) => (monospace ? 'monospace' : 'inherit'),
  },
}));

/**
 * @summary Текст с возможностью его копирования.
 *
 * @description API компонента полностью повторяет API компонента
 * Typography от material-ui. После текста, который передаётся в
 * качестве children, сразу следует иконка копирования со всплывающей
 * подсказкой "Скопировать". После нажатия на неё, текст скопируется
 * в буфер обмена, иконка заменится на зелёную галочку, а текст
 * всплывающей подсказки заменится на "Скопировано". Через секунду
 * иконка и текст подсказки вернутся в изначальную форму.
 */
// TODO: very stupid idea. children could be a link. What to copy ?!
export const TypographyWithCopy: FC<Props> = (props) => {
  const { monospace = false, children, ...typographyProps } = props;
  const classes = useStyles({ monospace });
  const text = children.toString();
  return (
    <Box component="div" className={classes.inline}>
      <Typography noWrap className={classes.typography} {...typographyProps}>
        {text}
      </Typography>
      <CopyIcon text={text} iconSize={1} />
    </Box>
  );
};
